import { buildGlobalReferenceContext } from '../../../../context/buildGlobalReferenceContext.mjs';

const [SingleSelectGroupContextProvider, useSingleSelectGroupContext] = buildGlobalReferenceContext(
  "SingleSelectGroup"
);

export { SingleSelectGroupContextProvider, useSingleSelectGroupContext };
//# sourceMappingURL=group-context.mjs.map
